import React, { useState, useEffect } from 'react'
import { isMobile } from '../../../../Constants'
import classes from '../auctions.module.css'

/**
 * Represents the auction details component.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Array} props.auction_details - The list of auction details.
 * @param {Function} props.setauction_details - Function to update the auction details.
 * @returns {React.ReactElement} The auction details component.
 */
const AuctionDetails = ({
    auction_details = [],
    setauction_details = ''
}) => {
    // const [details, setdetails] = useState([])

    /**
     * Updates the local state when auction_details prop changes.
     *
     * @hook
     * @returns {void}
     */
    // useEffect(() => {
    //     setdetails(auction_details)
    // }, [auction_details])

    /**
     * Handles changes in auction details.
     *
     * @param {string} key - The key of the detail to be updated.
     * @param {number} value - The new value for the detail.
     * @param {number} id - The ID of the auction being updated.
     * @returns {void}
     */
    const changeHandler = (key, value, id) => {
        var temp = auction_details.map((auction) => {
            if (id === auction.auction_id) {
                auction[key] = value
            }
            return auction
        })
        // setdetails(temp)
        setauction_details(temp)
    }

    return (
        <div>
            {isMobile() ? null
                : <div className={classes['auction_details_table_header']}>
                    <div className={classes['description']}>Auction Description</div>
                    <div className={classes['openingamt']}>Opening Amount</div>
                    <div className={classes['biddecrement']}>Bid Decrement</div>
                    {/* <div className={classes['delete']}></div> */}
                    <div className={classes['biddecrement']}>Volume/Quantity</div>
                    <div className={classes['biddecrement']}>Baseline Rate</div>
                </div>}
            <div className={classes['details']}>
                {auction_details && auction_details.length > 0 ?
                    auction_details.map(value => {
                        return <div className={classes['auction_details_table_row']} key={value.auction_id}>
                            <div className={classes['description']}>{value.auction_description}</div>
                            <div className={classes['openingamt']}>
                                <input type="number" value={value.starting_amount > 0 ? value.starting_amount : ''} placeholder='0' style={{ width: '75%', margin: '0' }} name="starting_amount" onChange={e => changeHandler(e.target.name, parseInt(e.target.value), value.auction_id)} />
                            </div>
                            <div className={classes['biddecrement']}>
                                <input type="number" value={value.bid_decrement_amount > 0 ? value.bid_decrement_amount : ''} placeholder='0' style={{ width: '75%', margin: '0' }} name="bid_decrement_amount" onChange={e => changeHandler(e.target.name, parseInt(e.target.value), value.auction_id)} />
                            </div>
                            {/* <div className={classes['delete']}>
                                {/* <button className="btn btn-sm btn-light" style={{padding:'3px 5px'}}><i className="fa fa-trash"></i></button> */}
                            {/* </div> */}
                            <div className={classes['biddecrement']}>
                                <input type="number" value={value.unit_metric > 0 ? value.unit_metric : ''} placeholder='0' style={{ width: '75%', margin: '0' }} name="unit_metric" onChange={e => changeHandler(e.target.name, parseInt(e.target.value), value.auction_id)} />
                            </div>
                            <div className={classes['biddecrement']}>
                                <input type="number" value={value.baseline_rate > 0 ? value.baseline_rate : ''} placeholder='0' style={{ width: '75%', margin: '0' }} name="baseline_rate" onChange={e => changeHandler(e.target.name, parseInt(e.target.value), value.auction_id)} />
                            </div>
                        </div>
                    })
                    : null}
            </div>
        </div>
    )
}

export default AuctionDetails
